import { AppId } from '@inno-tools/container-bridge'
import { useLocation, useNavigate } from 'react-router-dom'
import { useHistory } from 'shared/hooks/useHistory'
import { useUserContext } from 'shared/hooks/useUserContext'

import { useAvailableApps } from '../hooks/useAvailableApps'
import { FullPageAppTemplate } from '../templates'

export const ProfileApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const history = useHistory()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.PROFILE}
      scope='profile'
      envKey={apps[AppId.PROFILE].runtimeEnvKey}
      entryPath='./ProfileApp'
      url={process.env.REACT_APP_PROFILE_APP_DEV_PATH}
      appName={apps[AppId.PROFILE].name}
      appProps={{
        user,
        history: history,
        appPath: apps[AppId.PROFILE].path,
        initialPath: location.pathname,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location
          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}
